import Layout from '@/features/layout/index';
import ContactOptions from '@/features/contact-options';
export default function HelpPage({}) {
	// Form State

	return (
		<Layout>
			<main className=" flex flex-col mx-4">
				<h1 className="text-3xl text-center mt-8">
					Have Questions or Need Help?
				</h1>
				<ContactOptions />
			</main>
		</Layout>
	);
}
